import { useLoggedGeladaLazyQuery } from '@netfront/gelada-identity-library';

import { GET_HAS_PARTNER } from './useHasPartner.graphql';
import { IHasPartnerQueryGraphQLResponse, IUseHasPartner, IUseHasPartnerOptions } from './useHasPartner.interfaces';


const useHasPartner = (options?: IUseHasPartnerOptions): IUseHasPartner => {
  const { fetchPolicy, onCompleted, onError, query } = options ?? ({} as IUseHasPartnerOptions);

  const [executeHasPartner, { loading: isLoading }] = useLoggedGeladaLazyQuery<IHasPartnerQueryGraphQLResponse>({
    options: {
      fetchPolicy: fetchPolicy ?? 'cache-and-network',
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }
        const {
          partner: { hasPartner },
        } = data;

        onCompleted({
          hasPartner,
        });
      },
      onError,
    },
    query: query ?? GET_HAS_PARTNER,
  });

  const handleHasPartner = async () => {
    await executeHasPartner();
  };

  return {
    handleHasPartner,
    isLoading,
  };
};

export { useHasPartner };
